<template>
<div class="main-container">
  <div v-if="showIntro && !getudfId">
    <tl-header type="h1">
      <div>Misc Settings</div>
    </tl-header>
    <div class="row-container center">
      <div class="company-info">
        <img class="image" src="@/assets/settings.svg" />
        <!-- <div @click="goToPreferencesPage"><img class="closeImage" src="@/assets/close.png" /></div> -->
        <div class="fontStyle">
          <span>Lorem ipsum dolor sit amet consectetur adipisicing elit. 
              Maxime aperiam suscipit eveniet, ad quasi quam amet tempore excepturi autem doloribus a, 
              quo vitae consectetur? Nostrum illo iusto alias vitae distinctio.
          </span><br>
          <div class="divider"></div><br><br>
          <btn text="Get Started" type="secondary" @click="goToPreferencesPage" />
        </div>
      </div>
    </div>
    <bottom-action-container class="placeAtEnd">
      <template slot="end">
        <btn-skip @navClicked="navHandler"></btn-skip>
      </template>
    </bottom-action-container>
  </div>
  <div v-else>
    <misc @displayIntro="goToIntro" />
  </div>
</div>
</template>

<script>
import Misc from "./misc.vue";
import {mapGetters,mapActions,mapState} from 'vuex'
export default {
  name: 'MiscIntro',
  data() {
    return {
      showIntro: true
    }
  },
  components: {
    Misc
  },
  computed:{
    ...mapGetters({
      getudfId:'onboard/importUdf/getUdfId'
    })
  },
  methods: {
    navHandler(navType) {
      if (navType == 'back') {
        this.$validator.reset();
        this.$router.push({
          path: `/onboarding/entity/${this.$route.params.entity_index}/empCategories`
        });
      }
      if (navType == 'next') {
          this.showIntro = true
        // this.$validator.reset();
        // this.$router.push({
        //   path: "/onboarding"
        // });
      }
    },
    goToIntro() {
      this.showIntro = true;
    },
    goToPreferencesPage() {
      this.showIntro = false;
    }
  }
}
</script>

<style scoped>
.company-info {
  display: flex;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.25);
  background-color: #ffffff;
  align-items: flex-start;
  position: relative;
  width: 100%;
}

.closeImage {
  position: absolute;
  float: right;
  top: 10px;
  cursor: pointer;
  right: 10px;
}

.image {
  margin-top: 30px;
}

.building {
  width: 56px;
  height: 58px;
  object-fit: contain;
  margin: 25px 0 0 129px;
}

.fontStyle {
  margin-left: 20px;
  font-family: Montserrat;
  font-size: 16px;
  color: #404040;
}

.divider {
  color: #34c0be;
  border-bottom: 2px solid #34c0be;
  width: 60%;
  margin: 30px 0 0 5px;

}

.placeAtEnd {
  margin-top: 200px;
}
</style>
